module.exports = "dist/sem_foto.png?475d3b84d3dbb1d2d72dd12114f1a064";